import { gql } from "apollo-boost";

export const GET_POST_DETAILS_DATA = gql`
  query($slug: String!, $pageId: ID!) {
    page(id: $pageId) {
      seo {
        canonical
        metaDesc
        metaKeywords
        title
        focuskw
      }
    }
    publicationBy(slug: $slug) {
      id
      title
      date
      slug
      publicationCategories {
        nodes {
          name
          children {
            nodes {
              name
              publications(first: 10000) {
                nodes {
                  title
                  slug
                }
              }
            }
          }
        }
      }
      blocContenu {
        blocsContenus {
          ... on Publication_Bloccontenu_BlocsContenus_Titre {
            contenuTitre
            niveau
          }
          ... on Publication_Bloccontenu_BlocsContenus_Paragraphe {
            paragraphe
          }
          ... on Publication_Bloccontenu_BlocsContenus_Image {
            image {
              altText
              sourceUrl
            }
          }
          ... on Publication_Bloccontenu_BlocsContenus_GalerieImages {
            images {
              altText
              sourceUrl
            }
          }
          ... on Publication_Bloccontenu_BlocsContenus_Video {
            idVideo
            miniatureVideo {
              altText
              sourceUrl
            }
          }
          ... on Publication_Bloccontenu_BlocsContenus_Bouton {
            libelleBouton
            typeDeLien
            lienExterne
            lienInterne {
              ... on Page {
                slug
              }
            }
            fichier {
              mediaItemUrl
            }
            icone {
              altText
              sourceUrl(size: LARGE)
              srcSet
            }
          }
          ... on Publication_Bloccontenu_BlocsContenus_Espaceur {
            taille
          }
        }
      }
      publications {
        auteur {
          auteur
          biographie
          prenomNom
          photo {
            altText
            sourceUrl
          }
        }
        global {
          typePublication
          visuelPublication {
            altText
            sourceUrl
          }
          fichier {
            mediaItemUrl
          }
        }
      }
    }
  }
`;
